import { render } from "./StaffAssign.vue?vue&type=template&id=8c6bd876"
import script from "./StaffAssign.vue?vue&type=script&lang=js"
export * from "./StaffAssign.vue?vue&type=script&lang=js"

import "./StaffAssign.vue?vue&type=style&index=0&id=8c6bd876&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__